<app-btn-generar-resumen-mensual (procesoFinalizado)="procesoFinalizado($event)"
  *appRole="['Contratos.GenerarResumenMasivo']"></app-btn-generar-resumen-mensual>

<ngx-spinner [zIndex]="100" name="spResultadoEnvioMasivo" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
  type="ball-atom" [fullScreen]="false">
</ngx-spinner>
<br>
<br>
<mat-tab-group [(selectedIndex)]="selectedTabIndex">
  <mat-tab label="Ver procesos">
    <br>
    <h2>Seleccionar proceso masivo para ver detalle</h2>
    <form [formGroup]="formularioProceso">
      <mat-form-field appearance="outline" style="width: 100%;">
        <ngx-spinner [zIndex]="100" name="spBusquedaProcesoMasivo" bdColor="rgba(255,255,255,0.8)" size="small"
          color="#009688" type="line-scale" [fullScreen]="false">
        </ngx-spinner>

        <mat-label for="IdProcesoMasivo">Proceso Masivo</mat-label>
        <mat-select placeholder="Seleccione un proceso" formControlName="idProcesoMasivo"
          (selectionChange)="onProcesoMasivoChange($event.value)">

          <mat-option [value]="idProceso" *ngFor="let idProceso of lstResumenFilter; trackBy: trackByItems">
            {{ idProceso }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </mat-tab>
  <mat-tab label="Resumen del Proceso de Envío">

    <ngx-spinner [zIndex]="100" name="spResultadoEnvioMasivo" bdColor="rgba(255,255,255,0.8)" size="default"
      color="#009688" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <div [hidden]=!verTabla *ngIf="detalleResumen">

      <mat-card class="p-4">
        <mat-card-title>Resumen del Proceso de Envío</mat-card-title>
        <mat-card-content>
          <div class="row">
            <div class="col">
              <div><strong>ID Proceso Masivo: </strong> {{ detalleResumen.idProcesoMasivo }}</div>
              <div><strong>Duración Total: </strong> {{ (detalleResumen.duracionTotal / 60000) | number: '1.0-2' }}
                minutos
              </div>

              <div><strong>Fecha de Inicio: </strong> {{ detalleResumen.fechaInicio | date: 'short' }}</div>
              <div><strong>Fecha de Fin: </strong> {{ detalleResumen.fechaFin | date: 'short' }}</div>

            </div>
            <div class="col">
              <div><strong>Total Procesados: </strong> {{ detalleResumen.totalProcesados }}</div>
              <div><strong>Total Errores: </strong>
                <span style="color: red">{{ detalleResumen.totalErrores }}</span> / {{ detalleResumen.totalProcesados
                }}
              </div>
              <div><strong>Total Exitosos: </strong>
                <span style="color: green">{{ detalleResumen.totalExitosos }}</span> / {{
                detalleResumen.totalProcesados
                }}
              </div>
            </div>
            <div class="col">
              <div><strong>Resumen Generado OK: </strong>
                <span style="color: green">{{ detalleResumen.totalGeneracionResumenExitosos }}</span> / {{
                detalleResumen.totalProcesados }}
              </div>

              <div><strong>Resumen No Generados: </strong>
                <span style="color: red">{{ detalleResumen.totalGeneracionResumenErrores }}</span> / {{
                detalleResumen.totalProcesados }}
              </div>
              <div><strong>Archivo Generado OK: </strong>
                <span style="color: green">{{ detalleResumen.totalGeneracionArchivoExitosos }}</span> / {{
                detalleResumen.totalProcesados }}
              </div>
              <div><strong>Archivo No Generados: </strong>
                <span style="color: red">{{ detalleResumen.totalGeneracionArchivoErrores }}</span> / {{
                detalleResumen.totalProcesados }}
              </div>
            </div>
          </div>
        </mat-card-content>
        <br>
        <mat-card-content>
          <table mat-table [dataSource]="dataSource" matSort [hidden]=!verTabla class="mat-elevation-z8">

            <!-- Numero de Contrato -->
            <ng-container matColumnDef="numeroContrato">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Numero contrato</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <a [routerLink]="['/contratos',element.idContrato]"
                  class="contrato-link">{{element.numeroContrato}}</a>

              </td>
            </ng-container>

            <!-- Estado Envio Exitoso (Icono) -->
            <ng-container matColumnDef="generacionResumenExitosa">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Resumen</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.generacionResumenExitosa" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="!element.generacionResumenExitosa" color="warn">cancel</mat-icon>
              </td>
            </ng-container>

            <!-- Estado Envio Exitoso (Icono) -->
            <ng-container matColumnDef="generacionArchivoExitosa">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Archivo</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.generacionArchivoExitosa" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="!element.generacionArchivoExitosa" color="warn">cancel</mat-icon>
              </td>
            </ng-container>

            <!-- Estado Envio Exitoso (Icono) -->
            <ng-container matColumnDef="envioExitoso">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Envio correo</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.envioExitoso" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="!element.envioExitoso" color="warn">cancel</mat-icon>
              </td>
            </ng-container>

            <!-- Estado Envio Exitoso (Icono) -->
            <ng-container matColumnDef="emailValido">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Correo valido</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.emailValido" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="!element.emailValido" color="warn">cancel</mat-icon>
              </td>
            </ng-container>

            <ng-container matColumnDef="emailDestino">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Correo destino</span>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.emailDestino | titlecase}}
              </td>
            </ng-container>

            <ng-container matColumnDef="tiempoDuracionEnvio">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Duración/ms </span>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.tiempoDuracionEnvio}}
              </td>
            </ng-container>


            <ng-container matColumnDef="metodoEnvio">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Metodo envio</span>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.metodoEnvio | titlecase}}
              </td>
            </ng-container>

            <!-- Fecha Envio -->
            <ng-container matColumnDef="fechaEnvio">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Fecha envio</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <span>{{element.fechaEnvio | date:'yyyy-MM-dd HH:mm:ss'}}</span>
              </td>
            </ng-container>

            <!-- Mensaje con opción de expandir -->
            <ng-container matColumnDef="mensaje">
              <th mat-header-cell *matHeaderCellDef>
                <span>Mensaje</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <span [matTooltip]="element.mensaje">{{element.mensaje | slice:0:50}}...</span>
                <button mat-icon-button (click)="openMessageDialog(element.mensajeDetalle)">
                  <mat-icon>expand_more</mat-icon>
                </button>
              </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator showFirstLastButtons class="paginator" [hidden]=!verTabla [pageSize]="20"
            [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
          </mat-paginator>

          <app-sin-datos *ngIf="dataSource.data.length == 0 || dataSource.data == undefined"></app-sin-datos>
        </mat-card-content>
      </mat-card>

    </div>

  </mat-tab>
</mat-tab-group>
